export const getAddressComponent = (components, type, short = false) => {
  const safeComponents = Array.isArray(components) ? components : [];
  const component = safeComponents.find(
    (item) => Array.isArray(item?.types) && item.types.includes(type),
  );
  if (!component) return "";
  return short ? component.short_name || "" : component.long_name || "";
};

export const regionSummaryFromPlaceDetails = (placeResult) => {
  const components = placeResult?.address_components || [];
  const city =
    getAddressComponent(components, "locality") ||
    getAddressComponent(components, "postal_town") ||
    getAddressComponent(components, "sublocality") ||
    getAddressComponent(components, "administrative_area_level_2");
  const state = getAddressComponent(components, "administrative_area_level_1", true);
  const country =
    getAddressComponent(components, "country", true) ||
    getAddressComponent(components, "country");
  return [city, state, country].filter(Boolean).join(", ");
};

export const locationFieldsFromPlaceDetails = (placeResult) => {
  const components = placeResult?.address_components || [];
  return {
    city:
      getAddressComponent(components, "locality") ||
      getAddressComponent(components, "postal_town") ||
      getAddressComponent(components, "sublocality") ||
      getAddressComponent(components, "administrative_area_level_2"),
    county: getAddressComponent(components, "administrative_area_level_2"),
    state: getAddressComponent(components, "administrative_area_level_1", true),
    country:
      getAddressComponent(components, "country", true) ||
      getAddressComponent(components, "country"),
  };
};

export const addressFieldsFromPlaceDetails = (placeResult) => {
  const components = placeResult?.address_components || [];
  const streetNumber = getAddressComponent(components, "street_number");
  const route = getAddressComponent(components, "route");
  const postalCode = getAddressComponent(components, "postal_code");

  const latitude =
    typeof placeResult?.geometry?.location?.lat === "function"
      ? placeResult.geometry.location.lat()
      : placeResult?.geometry?.location?.lat;
  const longitude =
    typeof placeResult?.geometry?.location?.lng === "function"
      ? placeResult.geometry.location.lng()
      : placeResult?.geometry?.location?.lng;

  const city =
    getAddressComponent(components, "locality") ||
    getAddressComponent(components, "postal_town") ||
    getAddressComponent(components, "sublocality") ||
    getAddressComponent(components, "administrative_area_level_2");

  return {
    addressLine1: [streetNumber, route].filter(Boolean).join(" ").trim(),
    city,
    county: getAddressComponent(components, "administrative_area_level_2"),
    state: getAddressComponent(components, "administrative_area_level_1", true),
    country:
      getAddressComponent(components, "country", true) ||
      getAddressComponent(components, "country"),
    zipCode: postalCode,
    latitude:
      typeof latitude === "number" && Number.isFinite(latitude) ? latitude : undefined,
    longitude:
      typeof longitude === "number" && Number.isFinite(longitude) ? longitude : undefined,
    placeId: placeResult?.place_id || "",
  };
};
